<template>
  <div>
    <el-image src="static/img/images06.png" class="el-image-head"/>
    <div class="div-content">
      <div class="div-content-title">
        <label class="label-title">公司简介</label>
      </div>
      <div>
        <label class="label-content">
          慧源创新为客户提供开放的TaiShan Platform生态平台 ，为客户提供图传、飞控、
          云台、避障、TaiShanOS无人机系统全案服务 ，研发进度快 、 产品上市快，助力客户
          商业落地效率高。核心团队来自芯片设计上市公司，拥有丰富的工作经营  ， 在嵌入式
          软件、算法、硬件技术有7年以上深厚沉淀。
        </label>

      </div>
      <div class="div-content-title">
        <label class="label-title">公司使命</label>
      </div>
      <div>
        <label class="label-content">创作触动灵魂的美好作品！</label>
      </div>
      <div class="div-content-title">
        <label class="label-title">公司愿景</label>
      </div>
      <div>
        <label class="label-content">世界上每一个人一生至少有一次上帝视角的美好体验。</label>
      </div>
      <div class="div-content-title">
        <label class="label-title">价值观</label>
      </div>
      <div>
        <label class="label-content">以客户价值为中心，以奋斗者为本，坚持长期艰苦奋斗，坚持自我批判！</label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AboutUs'
}
</script>

<style scoped>
.el-image-head{
  height: 541px;
  width: 100%;
}
.div-content{
  width: 60%;
  margin-top: 80px;
  margin-left: 20%;
  padding-bottom: 200px;
}
.label-title{
  font-size: 26px;
  color: #FFB400;
  padding-bottom: 20px;
}
.label-content{
  font-size: 16px;
  color: black;
  letter-spacing:2px;
}
.div-content-title{
  margin-top: 40px;
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/AboutUs.vue